import { makeStyles, Theme } from '@freighthub/silhouette-core'
import { FC, useContext } from 'react'
import { useI18n } from 'utils/localisation'

import { getDelayTooltip } from '../service/TpDelayTooltip'
import { TpTimestampRangeCtx, TTpTimestampRangeCtx } from '../service/TpTimestampRangeContext'
import { DelayInfoIcon } from './TpDelayInfoIcon'

const useStyles = makeStyles<Theme>({
  nowrap: {
    whiteSpace: 'nowrap',
  },
})

export const testIds = {
  wordBreak: 'word_break',
  delayString: 'delay_string',
}

interface DelayStringCtx {
  showTooltip: boolean
  useSingleLine: boolean
}

interface DelayStringProps {
  colorClass: string
  delayString: string
  initialDate?: string
}

interface LeanDelayStringProps extends DelayStringProps, Partial<DelayStringCtx> {}

export const LeanDelayString: FC<LeanDelayStringProps> = ({
  colorClass,
  delayString,
  initialDate,
  showTooltip = true,
  useSingleLine = false,
}) => {
  const { translate } = useI18n()
  const classes = useStyles()
  return (
    <>
      {!useSingleLine && <wbr data-testid={testIds.wordBreak} />}
      <span className={classes.nowrap} data-testid={testIds.delayString}>
        &ensp;(
        <span className={colorClass}>{delayString}</span>)
        {showTooltip && initialDate && <DelayInfoIcon tooltip={getDelayTooltip(translate, initialDate)} />}
      </span>
    </>
  )
}

export const DelayString: FC<DelayStringProps> = (props) => {
  const { showTooltip, useSingleLine }: TTpTimestampRangeCtx = useContext(TpTimestampRangeCtx)
  return <LeanDelayString showTooltip={showTooltip} useSingleLine={useSingleLine} {...props} />
}
